import request from '@/utils/request' 

//行业类型统计
export function getPositionBarChatApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getPositionBarChat',
   params
  })
}

//就业率占比
export function getEmploymentRateApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getEmploymentRate',
   params
  })
}

//薪资分布
export function getSalaryDistributionApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getSalaryDistribution',
   params
  })
}

//劳动力分布
export function getMemberAreaCountApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getMemberAreaCount',
   params
  })
}

//就业薪资排行统计
export function getSalaryRankingApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getSalaryRanking',
   params
  })
}

//项目类型占比
export function getProjectTypeRationApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getProjectTypeRation',
   params
  })
}

//查询统计数量
export function getStatisticsCountApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getStatisticsCount',
   params
  })
}

//地区占比统计-求职人员
export function getAreaWantRateApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getAreaWantRate',
   params
  })
}

//地区占比统计-项目
export function getAreaProjectRateApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getAreaProjectRate',
   params
  })
}

//地区占比统计-企业
export function getAreaCompanyRateApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getAreaCompanyRate',
   params
  })
}

//求职偏好类型对比
export function getMemberPreferencesApi(params) {
  return request({
   method:'GET',
   url:'/api/statistics/getMemberPreferences',
   params
  })
}
